$(document).ready(function() {
    // 初始时，“返回顶部”标签隐藏
    $(".toTop").hide();
    $(window).scroll(function() {
        // 若滚动的高度，超出指定的高度后，“返回顶部”的标签出现。
        if($(document).scrollTop() >= 150) {
            $(".toTop").show();
        } else {
            $(".toTop").hide();
        }
    })
    // 绑定点击事件，实现返回顶部的效果
    $(".toTop").click(function() {
        $(document).scrollTop(0);
    })

})


// WEBPACK FOOTER //
// ./src/assets/js/global.js